import { Link } from 'react-router-dom'

export default function SiteFooter({ variant = 'default' }) {
  if (variant === 'minimal') {
    return (
      <footer className="border-t py-6">
        <div className="container mx-auto max-w-7xl px-6 text-center text-sm text-muted-foreground">
          © {new Date().getFullYear()} Tillio Payment LLC. All rights reserved.
        </div>
      </footer>
    )
  }

  return (
    <footer className="border-t bg-background py-16">
      <div className="container mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          <div>
            <img src="/wide2.png" alt="Tillio POS" className="h-8 w-auto mb-4" />
            <p className="text-sm text-muted-foreground">Operating System for Restaurants</p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Product</h3>
            <div className="flex flex-col gap-2">
              <Link to="/features" className="text-sm text-primary hover:underline">Features</Link>
              <Link to="/pricing" className="text-sm text-primary hover:underline">Pricing</Link>
              <Link to="/hardware" className="text-sm text-primary hover:underline">Hardware</Link>
              <Link to="/faq" className="text-sm text-primary hover:underline">FAQ</Link>
              <a href="https://app.tilliopayment.com" className="text-sm text-primary hover:underline">Sign In</a>
            </div>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Solutions</h3>
            <div className="flex flex-col gap-2">
              <Link to="/restaurant-pos" className="text-sm text-primary hover:underline">Restaurants</Link>
              <Link to="/cafe-pos" className="text-sm text-primary hover:underline">Cafés</Link>
              <Link to="/bar-pos" className="text-sm text-primary hover:underline">Bars</Link>
              <Link to="/bakery-pos" className="text-sm text-primary hover:underline">Bakeries</Link>
              <Link to="/fast-casual-pos" className="text-sm text-primary hover:underline">Fast Casual</Link>
              <Link to="/fine-dining-pos" className="text-sm text-primary hover:underline">Fine Dining</Link>
            </div>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Resources</h3>
            <div className="flex flex-col gap-2">
              <Link to="/stripe" className="text-sm text-primary hover:underline">Tillio + Stripe</Link>
              <Link to="/how-it-works" className="text-sm text-primary hover:underline">How it works</Link>
              <Link to="/payment-methods" className="text-sm text-primary hover:underline">Payment methods</Link>
              <Link to="/card-readers" className="text-sm text-primary hover:underline">Card readers</Link>
              <Link to="/guides" className="text-sm text-primary hover:underline">Guides</Link>
              <Link to="/compare/stripe" className="text-sm text-primary hover:underline">Tillio vs Stripe</Link>
              <Link to="/compare/payment-processors" className="text-sm text-primary hover:underline">Keep your Stripe</Link>
            </div>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <div className="flex flex-col gap-2">
              <Link to="/terms" className="text-sm text-primary hover:underline">Terms of Service</Link>
              <Link to="/privacy" className="text-sm text-primary hover:underline">Privacy Policy</Link>
              <a href="mailto:services@tilliopayment.com" className="text-sm text-primary hover:underline">Contact Us</a>
            </div>
          </div>
        </div>
        <div className="border-t pt-8 text-center">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Tillio Payment LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
